// extracted by mini-css-extract-plugin
module.exports = {"thumb_canvas_Grid":"CanvasGrid_thumb_canvas_Grid__Zkbn_","game_info":"CanvasGrid_game_info__oibtU"};